// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { transparent } = colors;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,

      // Keep every TextField (small or medium) the same height, regardless
      // of size. Vertical centering is left at MUI's default (center) so
      // start-adornment icons/labels stay centered inside the taller box.
      "& .MuiInputBase-root": {
        minHeight: 56,
      },
    },
  },
};

export default textField;
